import { setCollections } from '@common/redux/slice/database';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchCollections } from '@common/services/featherIO';
import { showAlert } from '@common/utils/ShowAlert';

export const useCollections = ({ appId }: { appId: string }) => {
  const dispatch = useDispatch();

  const _fetchCollections = useCallback(async () => {
    try {
      const collections = await fetchCollections(appId);
      dispatch(setCollections(collections));
    } catch (error) {
      // Runs at startup; offline this rejects. Swallow so it doesn't become an
      // unhandled rejection (which Crashlytics escalates into a native crash).
      console.error('===fetchCollections error', error);
      showAlert(
        'アプリが起動できません。電波状況が良好なエリアで再度実行してください。'
      );
    }
  }, [appId]);

  useEffect(() => {
    _fetchCollections();
  }, [_fetchCollections]);
};
